import { useSelector } from 'react-redux';
import { selectIsCNEnv, selectIsApp } from '../selectors';
import useDetectWechat from './useDetectWechat';

/**
 * Hide header/footer in CN App / Wechat webview
 * @returns {boolean}
 */
export default function useHideHeaderAndFooter() {
  const isCNEnv = useSelector(selectIsCNEnv);
  const isWechat = useDetectWechat();
  const isApp = useSelector(selectIsApp);
  return isCNEnv && (isWechat || isApp);
}
